// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NseM","label":"styles_label__2iMNF"};